import { Line3toLineV3 as i } from "../index.js";
function d(t, n) {
  t = i(t), n = i(n);
  const o = t[0], r = t[1], c = n[0], s = n[1];
  return e(o, c, s) !== e(r, c, s) && e(o, r, c) !== e(o, r, s);
}
function e(t, n, o) {
  return (o[2] - t[2]) * (n[0] - t[0]) > (n[2] - t[2]) * (o[0] - t[0]);
}
export {
  d as doLinesIntersect
};
//# sourceMappingURL=index20.js.map
